import { SsMount } from 'src/js/dom/mount.js';
import { velocity } from 'src/js/lib/velocity.js';
import { throttle } from 'lodash';
import {
  passBy,
  fuckUpscroll,
} from 'src/js/lib/offset.js';
import { scroller } from 'src/js/lib/scroll.js';

const initY = -100;
const animY = -50;

export class SsBack extends SsMount {
  constructor ( elm, tgt ) {
    super( elm );
    this.tgtElm = tgt;
    this.scrollID = throttle( this.scrollLsn.bind( this ), 200 );
    this.resizeID = throttle( this.resizeLsn.bind( this ), 60 );
    this.clickID = throttle( this.clickLsn.bind( this ), 60 );
    this.shown = false;
    this.upScroll = null;
  }

  async watch () {
    this.upScroll = fuckUpscroll();
    this.position();
    await this.initVelocity();
    window.addEventListener( 'resize', this.resizeID );
    window.addEventListener( 'scroll', this.scrollID );
  }

  blind () {
    window.removeEventListener( 'resize', this.resizeID );
    window.removeEventListener( 'scroll', this.scrollID );
    return this;
  }

  initVelocity () {
    return velocity( this.elm, {
      props: { translateY: `${ initY }%` },
      opts: { duration: 0 },
    });
  }

  scrollLsn () {
    const [ up, abs ] = this.upScroll();
    // Scroll upward
    if ( up && abs > 10 )
    {
      if ( passBy( this.tgtElm ) )
      {
        this.open();
      }
      else
      {
        this.close();
      }
    }
    // Scroll downward
    else if ( abs > 10 )
    {
      this.close();
    }
  }

  resizeLsn () {
    this.position();
  }

  position () {
    const vw = document.documentElement.clientWidth;
    const w = this.elm.clientWidth;
    const left = ( vw / 2 ) - ( w / 2 );
    this.$.css( { left } );
  }

  open () {
    if ( this.shown ) { return Promise.resolve(); }
    return velocity( this.elm, {
      props: {
        translateY: [ `${ animY }%`, `${ initY }%` ],
        opacity: [ 1, 1 ]
      },
      opts: {
        duration: 200,
        easing: 'easeOutSine',
        begin: () => {
          this.shown = true;
        },
      },
      cb: () => {
        this.$.on( 'click', this.clickID );
      },
    });
  }

  close () {
    if ( ! this.shown ) {
      return Promise.resolve();
    }
    return velocity( this.elm, {
      props: {
        opacity: [ 1, 1 ],
        translateY: [ `${ initY }%`, `${ animY }%` ],
      },
      opts: {
        duration: 200,
        easing: 'easeOutSine',
        begin: () => {
          this.shown = false;
          this.$.off( 'click', this.clickID );
        },
      },
    });
  }

  async clickLsn ( evt ) {
    evt.preventDefault();
    this.blind();
    await this.close();
    await scroller( 0, {
      duration: 600,
      easing: 'easeInOutQuad',
    } );
    this.watch();
  }
}
